enum ReleaseChannel {
  Stable = 'stable',
  Preview = 'preview',
}

export default ReleaseChannel;
